import React from 'react';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { useReduxDispatch, useReduxSelector } from '../../../../../../redux/hooks';
import { setActionExpanded } from '../../../../../../slices/TicketDetailUISlice';
import { Button } from '@progress/kendo-react-buttons';

interface SendEmailButtonProps {
    onClick: () => void;
}

const SendEmailButton: React.FC<ITicketProps> = (ticket) => {
    const navigate = useNavigate();
    const dispatch = useReduxDispatch();
    const actionExpanded = useReduxSelector(state => state.ticketDetailsUI.actionExpanded);

    const onNewActionClick = () => {
        if (isMobile)
            navigate('email');
        else
            dispatch(setActionExpanded(actionExpanded !== 2 ? 2 : 0));
    }

    return (
        <Button disabled={ticket.Is_Loading} onClick={onNewActionClick} className={`${actionExpanded === 2 && 'on'}`} size='large' imageUrl='./images/toolbar/email.png' title='Send email' ></Button>
    );
};

export default SendEmailButton;